import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function testimonialBlock() {
	const els = document.querySelectorAll('[data-js="testimonial-swiper"]');
	if (!els.length) return;

	els.forEach((el) => {
		if (el.swiper) return;

		const wrapper = el.closest('.testimonials') || el.parentElement;
		const prevEl = wrapper?.querySelector('[data-js="testimonial-prev"]');
		const nextEl = wrapper?.querySelector('[data-js="testimonial-next"]');

		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 24,
			loop: true,
			speed: 400,
			autoHeight: true,
			navigation: {
				prevEl,
				nextEl,
			},
		});
	});
}
